import { useState, useEffect } from "react";
import { UrlApi } from "../../../services/apirest";
import moment from "moment";

// import DatosReciboCard from "./DatosReciboCard";
import UseReceipt from "../../referencias-tablas/clientes/datoscliente/cuentacorriente/recibos/hooks/UseReceipt";
import ReciboDetalleContainer from "../../referencias-tablas/clientes/datoscliente/cuentacorriente/recibos/UI/MostrarDetalleRecibo/ReciboDetalleContainer";
import TabsMediosPago from "./TabsMediosPago";
import AccionesBar from "./AccionesBar";
import ImputacionModal from "../../referencias-tablas/clientes/datoscliente/cuentacorriente/recibos/UI/Imputaciones/ImputacionModal";

import { getTotalRecibo } from "../../referencias-tablas/clientes/datoscliente/cuentacorriente/recibos/selectors/receipt.selectors";

function FormRecibo({
  clienteData,
  comprEmitido,
  showToast,
  setCargaRecibo,
  recObligatorio = false,
  handleCloseAll,
}) {
  console.log("clienteData: ", clienteData);
  console.log("comprEmitido: ", comprEmitido);
  console.log("recObligatorio: ", recObligatorio);

  const {
    state,
    updateRecibo,
    addInstrumento,
    updateInstrumento,
    removeInstrumento,
    addInstrumentosQr,
    addTarjeta,
    updateTarjeta,
    removeTarjeta,
    updateNumRecibo,
    updateFechaDePago,
    submit,
    confirm,
    setImputaciones,
  } = UseReceipt();
  const [tiposInstrumento, setTiposInstrumento] = useState([]);
  const [bancos, setBancos] = useState([]);
  const [tiposTarjeta, setTiposTarjeta] = useState([]);
  const [marcasTarjeta, setMarcasTarjeta] = useState([]);
  const [isLoadingData, setIsLoadingData] = useState(true);
  const [valorMaximoRedondeo, setValorMaximoRedondeo] = useState(0);
  const [erroresValidacion, setErroresValidacion] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const totalCobrado = getTotalRecibo(state);
  const totalEsperado = parseFloat(state.recibo.totalEsperado) || 0;
  const [showDetalleDialog, setShowDetalleDialog] = useState(false);
  const [imputacionModalOpen, setImputacionModalOpen] = useState();
  // console.log("COMPROBANTE EMITIDO: " , comprEmitido)

  const handleClose = () => {
    setShowDetalleDialog(false);

    if (recObligatorio) {
      showToast("El recibo es obligatorio para esta operación.", "warning");
      return;
    }

    setCargaRecibo(false);

    showToast(
      "La factura fue emitida correctamente. No se generó el recibo.",
      "info",
    );
  };

  const totalesCoinciden =
    totalEsperado > 0 && Math.abs(totalCobrado - totalEsperado) < 0.01;
  const [previewData, setPreviewData] = useState(null);

  const handleImporteChange = (e, updateFn) => {
    const value = e.target.value;
    if (value.startsWith(",") || value.startsWith(".")) return;
    if (value !== "" && !/^\d*\.?\d*$/.test(value)) return;
    if (value !== "" && parseFloat(value) < 0) return;
    updateFn(value);
  };

  const handlePreview = () => {
    setErroresValidacion([]);

    const result = submit();

    if (!result.ok) {
      setErroresValidacion(result.errors);
      showToast("Corrige los errores del formulario antes de guardar", "error");
      return;
    }
    setPreviewData(result.payload);
  };

  const handleConfirm = async () => {
    setIsSubmitting(true);
    try {
      await confirm(previewData, {
        valorMaximoRedondeo,
        onSuccess: (msg) => {
          showToast(msg, "success");
          setShowDetalleDialog(false);
          handleCloseAll();
        },
        onWarning: (msg) => {
          showToast(msg, "warning");
          setShowDetalleDialog(false);
          handleCloseAll();
        },
        onError: (msg) => showToast(msg, "error"),
      });
    } catch (error) {
      showToast(
        error.message.length !== 0 ? error.message : error.error,
        "error",
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      setIsLoadingData(true);
      try {
        const [resBancos, resMediosDePago, resMarcasTarjeta, redondeoMaximo] =
          await Promise.all([
            fetch(`${UrlApi}/bancos`).then((r) => r.json()),
            fetch(`${UrlApi}/ctacte/recibos/tipos/pago`).then((r) => r.json()),
            fetch(`${UrlApi}/ctacte/recibos/marcas/tarjeta`).then((r) =>
              r.json(),
            ),
            fetch(`${UrlApi}/ctacte/recibos/maximos/redondeo`).then((r) =>
              r.json(),
            ),
          ]);

        setBancos(resBancos);
        setMarcasTarjeta(
          (Array.isArray(resMarcasTarjeta) ? resMarcasTarjeta : []).filter(
            (m) => m.anulada === 0,
          ),
        );
        setTiposTarjeta(resMediosDePago.filter((p) => p.tarjeta === 1));
        setTiposInstrumento(resMediosDePago.filter((p) => p.tarjeta === 0));
        setValorMaximoRedondeo(redondeoMaximo);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setIsLoadingData(false);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    updateRecibo("clienteCuit", comprEmitido?.cuit_dni);
    updateRecibo("numCliente", comprEmitido?.nro_sisven);
    updateRecibo("idTipoNegocio", clienteData?.id_negocio_cliente);
    updateRecibo("idCliente", clienteData?.id);
    updateRecibo("totalEsperado", comprEmitido?.importe_total);
    updateRecibo("efectivo", comprEmitido?.importe_total);
    updateNumRecibo("ptoVta", comprEmitido?.pto_venta);
    updateNumRecibo("numero", comprEmitido?.nro_comprobante);
    updateFechaDePago(
      "dia",
      moment(comprEmitido?.fecha_emision).date().toString(),
    );
    updateFechaDePago(
      "mes",
      (moment(comprEmitido?.fecha_emision).month() + 1).toString(),
    );
    updateFechaDePago(
      "ano",
      moment(comprEmitido?.fecha_emision).year().toString(),
    );
  }, [comprEmitido]);

  useEffect(() => {
    if (previewData) {
      setShowDetalleDialog(true);
    }
  }, [previewData]);

  return (
    <div>
      {/* <DatosReciboCard
        totalEsperado={state.recibo.totalEsperado}
        FechaDePago={state.recibo.FechaDePago}
        // onFechaChange={updateFechaDePago}
        numRecibo={state.recibo.numRecibo}
        onNumReciboChange={updateNumRecibo}
        usaReciboElectronico={state.recibo.usaReciboElectronico}
        onReciboElectronicoChange={(value) =>
          updateRecibo("usaReciboElectronico", value)
        }
        handleImporteChange={handleImporteChange}
        gridSize={4}
        spacing={2}
      /> */}
      <TabsMediosPago
        state={state}
        updateRecibo={updateRecibo}
        handleImporteChange={handleImporteChange}
        clienteData={clienteData}
        addInstrumento={addInstrumento}
        updateInstrumento={updateInstrumento}
        removeInstrumento={removeInstrumento}
        addInstrumentosQr={addInstrumentosQr}
        tiposInstrumento={tiposInstrumento}
        bancos={bancos}
        addTarjeta={addTarjeta}
        updateTarjeta={updateTarjeta}
        removeTarjeta={removeTarjeta}
        tiposTarjeta={tiposTarjeta}
        marcasTarjeta={marcasTarjeta}
        recObligatorio={recObligatorio}
      />
      <AccionesBar
        state={state}
        handlePreview={handlePreview}
        totalesCoinciden={totalesCoinciden}
        totalCobrado={totalCobrado}
        isSubmitting={isSubmitting}
        recObligatorio={recObligatorio}
        setImputacionModalOpen={setImputacionModalOpen}
        onClose={handleClose}
      />
      <ReciboDetalleContainer
        open={showDetalleDialog}
        onClose={() => setShowDetalleDialog(false)}
        data={previewData}
        onConfirm={handleConfirm}
        clienteData={clienteData}
      />
      <ImputacionModal
        open={imputacionModalOpen}
        onClose={() => setImputacionModalOpen(false)}
        mode="inline"
        clienteData={clienteData}
        cuit={clienteData?.cuit}
        saldoDisponible={totalCobrado}
        imputaciones={state.imputaciones}
        onSetImputaciones={setImputaciones}
      />
    </div>
  );
}

export default FormRecibo;
